import { useMemo } from "react";

import type { CrmEnrichmentI18nKeys } from "../../../types/translations";
import type { CrmEnrichmentJobObject } from "../../../types/types";
import JobSwitcher from "../JobSwitcher";

const OBJECT_TOOLTIP_KEY = "si.crm-enrichment.job-wizard.settings.object.tooltip";

type Props = {
    initialJobObject?: CrmEnrichmentJobObject | "";
    selectedJobObject: CrmEnrichmentJobObject | "";
    options: readonly CrmEnrichmentJobObject[];
    translationKeys: CrmEnrichmentI18nKeys;
    onSelectJobObject: (object: CrmEnrichmentJobObject) => void;
};

const JobObjectSwitcher = ({
    options,
    initialJobObject,
    selectedJobObject,
    translationKeys,
    onSelectJobObject,
}: Props) => {
    const tooltipKeys = useMemo(() => {
        if (!initialJobObject || selectedJobObject !== initialJobObject) {
            return undefined;
        }

        const selectedIndex = options.indexOf(selectedJobObject);

        return options.map((_, index) => (index === selectedIndex ? "" : OBJECT_TOOLTIP_KEY));
    }, [selectedJobObject, initialJobObject, options]);

    return (
        <JobSwitcher
            options={options}
            selectedOption={selectedJobObject}
            getTranslationKey={translationKeys.object}
            tooltipKeys={tooltipKeys}
            onSelectOption={onSelectJobObject}
        />
    );
};

export default JobObjectSwitcher;
